export default __webpack_public_path__ + "static/media/1 (8).9595b841.jpg";